module.exports = __webpack_public_path__ + "static/media/CityPins.00fe6aec.svg";